<template>
    <svg
        viewBox="0 0 284 186"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="284"
        height="186">
        <g opacity="0.58">
            <g filter="url(#filter0_i_3064_17040)">
                <path
                    d="M199.746 -31.074C200.923 -47.5008 179.841 -55.7007 169.046 -43.0151L122.331 11.884C117.505 17.5549 109.491 19.5531 102.492 16.8306L34.9132 -9.45487C19.3142 -15.5223 4.79077 1.4228 13.6821 15.3163L52.4221 75.8509C56.3877 82.0474 55.8266 90.0387 51.0301 95.6754L4.09589 150.832C-6.68345 163.499 5.42083 182.172 21.7484 178.064L92.1875 160.339C99.5244 158.493 107.228 161.489 111.232 167.747L149.679 227.824C158.591 241.75 180.597 236.344 181.771 219.94L186.886 148.518C187.409 141.219 192.668 135.055 199.933 133.227L270.909 115.367C287.198 111.268 288.694 89.256 273.095 83.1886L205.516 56.9031C198.517 54.1806 194.13 47.3588 194.656 40.0154L199.746 -31.074Z"
                    fill="url(#paint0_linear_3064_17040)" />
            </g>
            <path
                d="M169.427 -42.691C179.933 -55.0371 200.387 -47.0179 199.247 -31.1097L194.157 39.9797C193.615 47.5479 198.137 54.5693 205.335 57.3691L272.914 83.6546C288.047 89.5409 286.616 110.899 270.787 114.882L199.811 132.742C192.343 134.621 186.926 140.961 186.387 148.482L181.273 219.905C180.134 235.811 158.762 241.089 150.101 227.554L111.653 167.477C107.53 161.034 99.6056 157.957 92.0655 159.854L21.6264 177.579C5.73037 181.579 -5.96041 163.421 4.47668 151.156L51.4109 95.9994C56.3486 90.1967 56.9283 81.9646 52.8433 75.5814L14.1032 15.0467C5.49852 1.60113 19.5389 -14.8984 34.732 -8.98888L102.311 17.2966C109.506 20.0954 117.747 18.043 122.712 12.208L169.427 -42.691Z"
                stroke="white" />
        </g>
        <defs>
            <filter
                id="filter0_i_3064_17040"
                x="0"
                y="-49.209"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
                width="284"
                height="285">
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="9" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_3064_17040" />
            </filter>
            <linearGradient
                id="paint0_linear_3064_17040"
                x1="188.885"
                y1="-47.9617"
                x2="89.3408"
                y2="207.962"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop
                    offset="1"
                    stop-color="white"
                    stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>
